import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Select from 'react-select';
import { actions as CipRegisterActions } from './store/slice';
import { selectCipRegisterFilters } from './store/selectors';

const { setStatus, resetFilters } = CipRegisterActions;

const statusOptions = [
  { value: 'Pending', label: 'Pending' },
  { value: 'In Review', label: 'In Review' },
  { value: 'Approved', label: 'Approved' },
  { value: 'Rejected', label: 'Rejected' },
  { value: 'Cancelled', label: 'Cancelled' },
];

const CipRegisterFilter = () => {
  const dispatch = useDispatch();
  const filters = useSelector(selectCipRegisterFilters);

  return (
    <div className="card mb-0">
      <div className="card-body pb-0">
        <div className="row">
          <div className="col-lg-3 col-sm-6 col-12">
            <div className="input-blocks">
              <label>Status</label>
              <Select
                classNamePrefix="react-select"
                options={statusOptions}
                placeholder="Filter by Status"
                isClearable
                value={filters.status}
                onChange={val => dispatch(setStatus(val))}
              />
            </div>
          </div>
          <div className="col-lg-3 col-sm-6 col-12 ms-auto">
            <div className="input-blocks">
              <label>&nbsp;</label>
              <button
                className="btn btn-secondary d-block"
                onClick={() => dispatch(resetFilters())}
              >
                Reset Filters
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CipRegisterFilter;
